import {
  Button,
  Menu,
  MenuItemCheckbox,
  MenuList,
  MenuPopover,
  MenuProps,
  MenuTrigger,
} from "@fluentui/react-components";

import { ComponentProps, ElementType, memo, useCallback } from "react";
import SubtitlesOutlineIcon from "~icons/material-symbols/subtitles-outline";
import { EllipsisTooltip } from "../../../components/EllipsisTooltip/EllipsisTooltip";
import { useAppData } from "../../../hooks";
import { FootnoteItem } from "../../../types/enums/FootnoteItem";

type SuggestionFootnoteMenuProps = {
  appId: string;
} & ComponentProps<ElementType>;

export const SuggestionFootnoteMenu = memo(function SuggestionFootnoteMenu({
  appId,
  children,
}: SuggestionFootnoteMenuProps) {
  const [footnoteItems, setFootnoteItems] = useAppData<Array<string>>(appId, "footnoteItems");

  const onFootNoteSelectionChange = useCallback<MenuProps["onCheckedValueChange"]>(
    (e, { checkedItems }) => {
      setFootnoteItems(checkedItems);
    },
    [setFootnoteItems]
  );

  return (
    <Menu checkedValues={{ footnotes: footnoteItems }} onCheckedValueChange={onFootNoteSelectionChange}>
      <MenuTrigger disableButtonEnhancement>
        <Button
          appearance="transparent"
          icon={
            <EllipsisTooltip content="Change displayed metadata" positioning={{ align: "center", offset: 4 }}>
              <SubtitlesOutlineIcon />
            </EllipsisTooltip>
          }
        />
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <MenuItemCheckbox name="footnotes" value={FootnoteItem.RELEVANCY}>
            Relevancy Score
          </MenuItemCheckbox>
          <MenuItemCheckbox name="footnotes" value={FootnoteItem.DOCUMENTS}>
            Source Documents
          </MenuItemCheckbox>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
});
